(function () {
  const GA_ID = "G-SNRLTT44RK";
  const CONSENT_KEY = "forsyt_cookie_consent_v1";
  const GA_SRC = "https://www.googletagmanager.com/gtag/js?id=" + GA_ID;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function () {
      window.dataLayer.push(arguments);
    };

  window.gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    wait_for_update: 500,
  });

  function readConsent() {
    try {
      return window.localStorage.getItem(CONSENT_KEY);
    } catch (error) {
      return null;
    }
  }

  function writeConsent(value) {
    try {
      window.localStorage.setItem(CONSENT_KEY, value);
    } catch (error) {
      /* Ignore storage failures; the current page state still updates. */
    }
  }

  window.loadGoogleAnalytics = function () {
    if (document.querySelector('script[src="' + GA_SRC + '"]')) {
      return;
    }

    const script = document.createElement("script");
    script.async = true;
    script.src = GA_SRC;
    document.head.appendChild(script);

    window.gtag("js", new Date());
    window.gtag("config", GA_ID, { anonymize_ip: true });
  };

  window.grantForsytAnalyticsConsent = function () {
    window.gtag("consent", "update", {
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
      analytics_storage: "granted",
    });
    window.loadGoogleAnalytics();
  };

  function setupCookieBanner() {
    const banner = document.getElementById("cookie-banner");
    const acceptButton = document.getElementById("cb-accept");
    const rejectButton = document.getElementById("cb-reject");
    const status = readConsent();

    if (status === "accepted") {
      window.grantForsytAnalyticsConsent();
    }

    if (!banner) {
      window.openCookiePreferences =
        window.openCookiePreferences ||
        function () {
          window.location.href = "/#cookie-settings";
        };
      return;
    }

    window.openCookiePreferences = function () {
      banner.style.display = "block";
    };

    if (!status) {
      banner.style.display = "block";
    }

    if (acceptButton) {
      acceptButton.addEventListener("click", function () {
        writeConsent("accepted");
        banner.style.display = "none";
        window.grantForsytAnalyticsConsent();
      });
    }

    if (rejectButton) {
      rejectButton.addEventListener("click", function () {
        writeConsent("rejected");
        banner.style.display = "none";
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupCookieBanner);
  } else {
    setupCookieBanner();
  }
})();
